export { default as AppointmentTimeslots } from "./appointmentTimeslots";
